export var RopType = /* @__PURE__ */ ((RopType2) => {
  RopType2["CSS2D"] = "CSS2DRenderer";
  RopType2["CSS3D"] = "CSS3DRenderer";
  RopType2["WEBGL"] = "WebGLRenderer";
  return RopType2;
})(RopType || {});
